import { FC } from 'react';
import security from 'stores/security';
import { AccountCustomerTypeEnum } from 'types/user';
import styles from './style.scss';

function getAccountType() {
    if (security.isIRAAccount) {
        switch (security.currentAccount!.customerType) {
            case AccountCustomerTypeEnum.IRA_ROTH:
                return __('Roth IRA');
            case AccountCustomerTypeEnum.IRA_TRADITIONAL:
                return __('Traditional IRA');
            case AccountCustomerTypeEnum.IRA_ROLLOVER:
                return __('Rollover IRA');
            default:
                break;
        }
    }

    return __('Individual');
}

interface FullProps {
    accountNo: string;
}

const Full: FC<FullProps> = ({ accountNo }) => {
    return (
        <div>
            <div className={styles.title}>{__('Transfer To')}</div>
            <div className={styles.transferItem}>
                <div className={styles.label}>{__('Receiving firm')}</div>
                <div className={styles.content}>{__('TradeUP Securities, Inc.')}</div>
            </div>
            <div className={styles.transferItem}>
                <div className={styles.label}>{__('Account Type')}</div>
                <div className={styles.content}>{getAccountType()}</div>
            </div>
            <div className={styles.transferItem}>
                <div className={styles.label}>{__('Account')}</div>
                <div className={styles.content}>{accountNo}</div>
            </div>
        </div>
    );
};

export default Full;
